import { render, staticRenderFns } from "./ChecklistInspectionTab.vue?vue&type=template&id=1cfe7012&scoped=true"
import script from "./ChecklistInspectionTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ChecklistInspectionTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChecklistInspectionTab.vue?vue&type=style&index=0&id=1cfe7012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfe7012",
  null
  
)

export default component.exports